import React from 'react';

interface State {
  error: Error | null;
  errorInfo: React.ErrorInfo | null;
}

export class ErrorBoundary extends React.Component<{ children: React.ReactNode }, State> {
  state: State = { error: null, errorInfo: null };

  static getDerivedStateFromError(error: Error): State {
    return { error, errorInfo: null };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('App crashed:', error, errorInfo);
    this.setState({ error, errorInfo });
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{ padding: 40, fontFamily: 'monospace', background: '#fef2f2', minHeight: '100vh' }}>
          <h1 style={{ color: '#991b1b', fontSize: 24, marginBottom: 20 }}>⚠️ App crashed</h1>
          <p style={{ marginBottom: 10 }}><strong>Error:</strong> {this.state.error.message}</p>
          <pre style={{ background: '#fff', padding: 20, borderRadius: 8, overflow: 'auto', fontSize: 12, border: '1px solid #fecaca', maxHeight: 400 }}>
            {this.state.error.stack}
          </pre>
          <button
            onClick={() => { localStorage.clear(); window.location.reload(); }}
            style={{ marginTop: 20, padding: '10px 20px', background: '#dc2626', color: 'white', border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: 600 }}
          >
            Clear storage & reload
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
